<template>
    <div class="has-data">
        <div class="identify-data">
            <div class="data-header">
                <div class="emotion-time">
                    <img
                        src="../assets/images/emotion_time.png"
                        alt="emotion_time"
                        class="emotion-time"
                    />
                    <div class="time-text">{{ recently_data.dateTime }}</div>
                </div>                
            </div>
            <div class="identify-emo">
                <div class="emo-item">
                    <div class="emo-item-name">心情</div>
                    <img
                        src="../assets/images/emotion1.png"
                        alt=""
                        v-if="recently_data.emotionIcn == 3"
                    />
                    <img
                        src="../assets/images/emotion2.png"
                        alt=""
                        v-if="recently_data.emotionIcn == 2"
                    />
                    <img
                        src="../assets/images/emotion3.png"
                        alt=""
                        v-if="recently_data.emotionIcn == 1"
                    />
                    <div class="emo-identify" :style="recently_data.emotionColor">
                        {{ formatEmotion(recently_data).emotion.short_content }}
                    </div>
                </div>
                <div class="emo-item">
                    <div class="emo-item-name">疲劳</div>
                    <img src="../assets/images/tired1.png" alt="" v-if="recently_data.tiredIcn == 1"/>
                    <img src="../assets/images/tired2.png" alt="" v-if="recently_data.tiredIcn == 2"/>
                    <img src="../assets/images/tired3.png" alt="" v-if="recently_data.tiredIcn == 3"/>
                    <div class="emo-identify" :style="recently_data.tiredColor">
                        {{ formatEmotion(recently_data).tired.short_content }}
                    </div>
                </div>
                <div class="emo-item">
                    <div class="emo-item-name">压力</div>
                    <img src="../assets/images/stress1.png" alt="" v-if="recently_data.stressIcn == 1"/>
                    <img src="../assets/images/stress2.png" alt="" v-if="recently_data.stressIcn == 2"/>
                    <img src="../assets/images/stress3.png" alt="" v-if="recently_data.stressIcn == 3"/>
                    <div class="emo-identify" :style="recently_data.stressColor">
                        {{ formatEmotion(recently_data).stress.short_content }}
                    </div>
                </div>
            </div>
            <div class="emotion-index">
                <div class="index-title">
                    <img
                        src="../assets/images/emotion1.png"
                        class="index-icn"
                        v-if="recently_data.emotionIcn == 3"
                    />
                    <img
                        src="../assets/images/emotion2.png"
                        class="index-icn"
                        v-if="recently_data.emotionIcn == 2"
                    />
                    <img
                        src="../assets/images/emotion3.png"
                        class="index-icn"
                        v-if="recently_data.emotionIcn == 1"
                    />
                    <div class="index-name">心情指数</div>
                </div>
                <div class="index-identify">
                    <div class="identify-num" :style="recently_data.emotionColor">
                        {{ formatEmotion(recently_data).emotion.index }}
                    </div>
                    <div class="identify-point">
                        <img
                            src="../assets/images/point-icn1.png"
                            alt=""
                            v-if="recently_data.emotionIcn == 3"
                        />
                        <img
                            src="../assets/images/point-icn2.png"
                            alt=""
                            v-if="recently_data.emotionIcn == 2"
                        />
                        <img
                            src="../assets/images/point-icn3.png"
                            alt=""
                            v-if="recently_data.emotionIcn == 1"
                        />
                        <div class="time-point-text" :style="recently_data.emotionColor">
                            {{ formatEmotion(recently_data).emotion.short_content }}
                        </div>
                    </div>
                    <div class="end-point">
                        {{ formatEmotion(recently_data).emotion.long_content }}
                    </div>
                </div>
                <div class="advice">
                    <div class="advice-title">
                        <img src="../assets/images/advice.png" alt="" />
                        <div class="advice-title-text">建议</div>
                    </div>
                    <div class="advice-text">
                        {{ formatEmotion(recently_data).emotion.suggestion }}
                    </div>
                </div>
            </div>
            <div class="emotion-index">
                <div class="index-title">
                    <img
                        src="../assets/images/tired1.png"
                        class="index-icn"
                        v-if="recently_data.tiredIcn == 1"
                    />
                    <img
                        src="../assets/images/tired2.png"
                        class="index-icn"
                        v-if="recently_data.tiredIcn == 2"
                    />
                    <img
                        src="../assets/images/tired3.png"
                        class="index-icn"
                        v-if="recently_data.tiredIcn == 3"
                    />
                    <div class="index-name">疲劳指数</div>
                </div>
                <div class="index-identify">
                    <div class="identify-num" :style="recently_data.tiredColor">
                        {{ formatEmotion(recently_data).tired.index }}
                    </div>
                    <div class="identify-point">
                        <img
                            src="../assets/images/point-icn1.png"
                            alt=""
                            v-if="recently_data.tiredIcn == 1"
                        />
                        <img
                            src="../assets/images/point-icn2.png"
                            alt=""
                            v-if="recently_data.tiredIcn == 2"
                        />
                        <img
                            src="../assets/images/point-icn3.png"
                            alt=""
                            v-if="recently_data.tiredIcn == 3"
                        />
                        <div class="time-point-text" :style="recently_data.tiredColor">
                            {{ formatEmotion(recently_data).tired.short_content }}
                        </div>
                    </div>
                    <div class="end-point">
                        {{ formatEmotion(recently_data).tired.long_content }}
                    </div>
                </div>
                <div class="advice">
                    <div class="advice-title">
                        <img src="../assets/images/advice.png" alt="" />
                        <div class="advice-title-text">建议</div>
                    </div>
                    <div class="advice-text">
                        {{ formatEmotion(recently_data).tired.suggestion }}
                    </div>
                </div>
            </div>
            <div class="emotion-index">
                <div class="index-title">
                    <img
                        src="../assets/images/stress1.png"
                        class="index-icn"
                        v-if="recently_data.stressIcn == 1"
                    />
                    <img
                        src="../assets/images/stress2.png"
                        class="index-icn"
                        v-if="recently_data.stressIcn == 2"
                    />
                    <img
                        src="../assets/images/stress3.png"
                        class="index-icn"
                        v-if="recently_data.stressIcn == 3"
                    />
                    <div class="index-name">压力指数</div>
                </div>
                <div class="index-identify">
                    <div class="identify-num" :style="recently_data.stressColor">
                        {{ formatEmotion(recently_data).stress.index }}
                    </div>
                    <div class="identify-point">
                        <img
                            src="../assets/images/point-icn1.png"
                            alt=""
                            v-if="recently_data.stressIcn == 1"
                        />
                        <img
                            src="../assets/images/point-icn2.png"
                            alt=""
                            v-if="recently_data.stressIcn == 2"
                        />
                        <img
                            src="../assets/images/point-icn3.png"
                            alt=""
                            v-if="recently_data.stressIcn == 3"
                        />
                        <div class="time-point-text" :style="recently_data.stressColor">
                            {{ formatEmotion(recently_data).stress.short_content }}
                        </div>
                    </div>
                    <div class="end-point">
                        {{ formatEmotion(recently_data).stress.long_content }}
                    </div>
                </div>
                <div class="advice">
                    <div class="advice-title">
                        <img src="../assets/images/advice.png" alt="" />
                        <div class="advice-title-text">建议</div>
                    </div>
                    <div class="advice-text">
                        {{ formatEmotion(recently_data).stress.suggestion }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {  describe } from "../api/emotion";
export default {
    data() {
        return {
            recently_data:{},
            indicators_data:[],
        };
    },
    computed: {
        
    },
    methods: {        
        describeAll(){
            describe().then(res=>{
                if(res.status==200){
                    this.indicators_data=res.data.indicators 
                }else{
                    this.$toast('暂无数据');
                }                               
            })
        },
        formatEmotion(one){
            let emotion={}
            let tired={}
            let stress={}            
            for(let i=0;i<this.indicators_data.length;i++){
                let item=this.indicators_data[i]
                if(item.dimension=='emotion'){
                    if(one.emotion_index>=item.min&&one.emotion_index<=item.max){
                        emotion={index:one.emotion_index,short_content:item.short_content,long_content:item.long_content,suggestion:item.suggestion}
                    }
                }
                if(item.dimension=="tired"){
                    if(one.tired_index>=item.min&&one.tired_index<=item.max){
                        tired={index:one.tired_index,short_content:item.short_content,long_content:item.long_content,suggestion:item.suggestion}
                    }
                }
                if(item.dimension=="stress"){
                    if(one.stress_index>=item.min&&one.stress_index<=item.max){
                        stress={index:one.stress_index,short_content:item.short_content,long_content:item.long_content,suggestion:item.suggestion}
                    }
                }
            }
            return {emotion,tired,stress}
        },
    },
    created() {
        this.describeAll()
        let details=sessionStorage.getItem('details')
        let emotion=JSON.parse(details)
        this.recently_data=emotion          
    },
};
</script>
<style lang='less' scoped>
.has-data{
    padding: 16px;
    padding-bottom: 60px;
}
.identify-data{
    background-color: #fff;
    border-radius: 10px;
    padding: 12px;
    padding-bottom: 30px;
}
.data-header{
    height: 24px;
    display: flex;
    justify-content: space-between;
}
.emotion-time{
    height: 24px;
    display: flex;
    justify-content: flex-start;
}
.emotion-time{
    height: 24px;
}
.time-text{
    height: 24px;
    line-height: 24px;
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-left: 10px;
}
.identify-emo{
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    margin-top: 14px;
}
.emo-item{
    width: 100px;
    padding: 12px 0px;
    background-color: #FBFCFC;
    border-radius: 10px;
}
.emo-item-name{
    height: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
}
.emo-item img{
    display: block;
    height: 40px;
    width: 40px;
    margin: 10px auto;
}
.emo-identify{
    height: 14px;
    line-height: 14px;
    font-weight: 500;
    font-size: 14px;
    color: #01D6D6;
    text-align: center;
}
.index-title{
    height: 24px;
    display: flex;
    justify-content: flex-start;
    margin-top: 40px;
}
.index-icn{
    height: 24px;
    display: block;
    margin-right: 10px;
}
.index-name{
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    font-weight: bolder;
    color: #333;
}
.identify-num{
    height: 32px;
    line-height: 32px;
    font-size: 32px;
    color: #55CF04;
    text-align: center;
    margin-top: 13px;
}
.identify-point{
    height: 16px;
    display: flex;
    justify-content: center;
    margin-top: 11px;
}
.identify-point img{
    display: block;
    height: 16px;
    margin-right: 5px;
}
.time-point-text{
    height: 16px;
    line-height: 16px;
    color: #55CF04;
    font-size: 14px;
    font-weight: 500;
}
.end-point{
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    margin-top: 13px;
}
.advice{
    background-color: #FBFCFC;
    border-radius: 10px;
    padding: 12px;
    margin-top: 12px;
}
.advice-title{
    height: 16px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 9px;
}
.advice-title img{
    display: block;
    height: 16px;
}
.advice-title-text{
    height: 16px;
    line-height: 16px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
}
.advice-text{
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
}
</style>